// Altera a posição da imagem no mobile
$(function () {
  if (isMobileX(760)) {
    $("[data-pos]").each(function () {
      const classGrid = $(this).data("pos");
      const elementGridMobile = $("." + classGrid);

      // elementGridMobile.append(this);

      $(this).insertAfter(elementGridMobile);
    });
  }
});
